import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ModuleService {
  constructor() {}

  getModule(rol: string) {
    const modules = {
      Preescolar: [
        {
          icon: "fas fa-book",
          title: "Guías del maestro y recursos digitales",
          url: "/resource/content/0",
        },
        {
          title: "Documentos de gestión académica",
        },
        {
          title: "Catálogo de servicios pedagógicos",
        },
        {
          title: "Sitios de interés recomendados",
        },
        {
          title: "Aplicaciones recomendadas",
        },
        {
          title: "Libros de texto en PDF",
        },
        {
          title: "Libros de texto descargables",
        },
        {
          title: "Libros y Guías del profesor",
        },
        {
          title: "Inglés ELT",
        },
      ],
      Primaria: [
        {
          title: "Guías del maestro y recursos digitales",
        },
        {
          title: "Documentos de gestión académica",
        },
        {
          title: "Catálogo de servicios pedagógicos",
        },
        {
          title: "Sitios de interés recomendados",
        },
        {
          title: "Aplicaciones recomendadas",
        },
        {
          title: "Generador de exámenes",
        },
        {
          title: "Libros de texto en PDF",
        },
        {
          title: "Libros de texto descargables",
        },
        {
          title: "Libros y Guías del profesor",
        },
        {
          title: "Inglés ELT",
        },
      ],
      Secundaria: [
        {
          title: "Guías del maestro y recursos digitales",
        },
        {
          title: "Documentos de gestión académica",
        },
        {
          title: "Generador de exámenes",
        },
        {
          title: "Generador de evaluaciones del Plan Lector",
        },
        // {
        //   "title": "Serie de Inglés - Help!",
        // },
        {
          icon: "fa fa-user-plus",
          title: "Catálogo de servicios pedagógicos",
          url: "/resource/services/3",
        },
        {
          title: "Sitios de interés recomendados",
        },
        {
          title: "Aplicaciones recomendadas",
        },
        {
          title: "Libros de texto en PDF",
        },
        {
          title: "Libros de texto descargables",
        },
        {
          title: "Libros y Guías del profesor",
        },
        {
          title: "Inglés ELT",
        },
      ],
      Bachillerato: [
        {
          title: "Recursos digitales",
        },
        {
          title: "Guías del maestro",
        },
        {
          title: "Catálogo de servicios pedagógicos",
        },
        {
          title: "Sitios de interés recomendados",
        },
        {
          title: "Aplicaciones recomendadas",
        },
        {
          title: "Generador de exámenes",
        },
        {
          title: "Generador de evaluaciones del Plan Lector",
        },
        {
          title: "Generador de reactivos para exámenes",
        },

        {
          title: "Generador de Cursos",
        },
        {
          title: "Contenedor de documentos",
        },
        {
          title: "Documentos de gestión académica",
        },

        {
          icon: "fa fa-user-plus",
          title: "Catálogo de servicios pedagógicos",
          url: "/resource/services/3",
        },
        {
          title: "Generador de avisos",
        },
        {
          title: "Aviso de privacidad",
        },
        {
          title: "Libros y Guías del profesor",
        },
        {
          title: "Inglés ELT",
        },
      ],
    };

    const module = modules[rol];

    return module;
  }
}
